module.exports = __webpack_public_path__ + "assets-cabinet/img/phone-missed.36c95921.svg";